/** Keep the Node copy in vetnebula-node/src/educationRecordPolicy.ts in step with this. */
export const EDUCATION_RECORD_RETENTION_YEARS = 7;

export const educationRecordRetentionSentence = (): string =>
  `Education records are kept while the learner's account is active and for ${EDUCATION_RECORD_RETENTION_YEARS} years after the account is deactivated.`;

export const schoolOfficialDesignation =
  "The Organization designates its administrators, directors, and managers, and the coaches assigned to a learner or mentoring that learner, as school officials with a legitimate educational interest. Those people act under the Organization's direct control. VetNebula maintains education records for the Organization.";

export const ferpaCoverageSentence =
  "The Organization records in its profile whether it is a school subject to FERPA. A private clinic may not be. These education-record limits apply to every Organization either way.";

export const studentStatementSentence =
  "If the Organization does not change a record, the learner can add a statement that stays with that record and is included whenever the record is released.";
